import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import { request, useQuery } from '@applyboard/ui-utils';
import { isResponseObject } from "./util";
function getEntityRequirementTemplates(options) {
  var _options$include, _options$filter, _options$filter2;
  var queryParams = [['include', (_options$include = options.include) === null || _options$include === void 0 ? void 0 : _options$include.join(',')], ['filter[entity_ids]', (_options$filter = options.filter) === null || _options$filter === void 0 ? void 0 : _options$filter.entityIds], ['filter[entity_type]', (_options$filter2 = options.filter) === null || _options$filter2 === void 0 ? void 0 : _options$filter2.entityType]].filter(function (param) {
    return !!param[1];
  });
  var queryString = new URLSearchParams(queryParams).toString();
  return request("/api/v2/entity_requirement_templates/?".concat(queryString), {
    // eslint-disable-next-line no-restricted-syntax -- TODO: Refactor this to use `schema`
    isExpectedResponse: isResponseObject,
    changeToCamelCase: true,
    flattenAttributes: true
  });
}
export function useEntityRequirementTemplates(options) {
  var _options$filter3, _options$filter4;
  var _useQuery = useQuery(['entityRequirementTemplates', (_options$filter3 = options.filter) === null || _options$filter3 === void 0 ? void 0 : _options$filter3.entityIds, (_options$filter4 = options.filter) === null || _options$filter4 === void 0 ? void 0 : _options$filter4.entityType, options.include], function () {
      return getEntityRequirementTemplates(options);
    }, {
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      enabled: options.enable
    }),
    data = _useQuery.data,
    isSuccess = _useQuery.isSuccess,
    isLoading = _useQuery.isLoading;
  return {
    isLoadingEntityRequirementTemplates: isLoading,
    entityRequirementTemplates: isSuccess ? data : null
  };
}